import React from "react";
import Dashboard from "../../dashboard/Dashboard";
import Button from "../../../components/buttons/Button";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";

const LanguageToTeach = [
  {
    id: 1,
    name: "Musa Daniel",
    email: "musa.daniel@gmail.com",
    request_date: "Aug 12, 2023 9:00am",
  },
  {
    id: 2,
    name: "John James",
    email: "john.philip@gmail.com",
    request_date: "Mat 3, 2023 1:00pm",
  },
  {
    id: 3,
    name: "Simeon Daniel",
    email: "simeon.daniel@gmail.com",
    request_date: "Jan 2, 2024 12:00am",
  },
  {
    id: 4,
    name: "Peter Solomon",
    email: "peter.solomon@gmail.com",
    request_date: "Sep 6, 2025 11:00am",
  },
];

export default function IntroductoryTable() {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <Dashboard pageTitle="Introductory Video">
      <div className={style.languagePage}>
        {/* Total Students Count */}
        <div className={style.counterCard}>
          <div className={style.titleTwrapper}>
            <FontAwesomeIcon
              icon={faArrowLeftLong}
              onClick={handleBackClick}
              className={style.backIcon}
            />
            <h2>Introductory Video List</h2>
          </div>
        </div>

        {/* Language to Teach Table */}
        <div className={style.pageTable}>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Request Date</th>
              </tr>
            </thead>
            <tbody style={{ cursor: "pointer" }}>
              {LanguageToTeach.map((request) => (
                <tr
                  key={request.id}
                  onClick={() =>
                    (window.location.href = `/review/introductory/${request.id}/details`)
                  }
                >
                  <td>{request.id}</td>
                  <td>{request.email}</td>
                  <td>{request.request_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Dashboard>
  );
}
